import { IconicLaptopError } from '@insify/design-system/iconic-icons';
import { TrackedButton } from '@objectiv/tracker-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import * as styles from './ErrorPage.module.css';

import type React from 'react';

const ErrorPage: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.errorPage}>
      <div className={styles.errorContainer}>
        <IconicLaptopError className={styles.errorIcon} />
        <h1 className={styles.errorTitle}>{t('error_page_title')}</h1>
        <p className={styles.errorMessage}>{t('error_page_message')}</p>
        <TrackedButton
          objectiv={{ id: 'go-home-button' }}
          className={styles.goHomeButton}
          type='button'
          onClick={handleGoHome}
        >
          {t('error_page_button')}
        </TrackedButton>
      </div>
    </div>
  );
};

export { ErrorPage };
